import React from 'react'

import banner from '../../assets/banners/mais-show-banner.png'
import { BannerImage, BannerLink } from './styles'

const MAIS_SHOW_URL = 'https://mais.show/parceiro/bd'

const MaisShowBanner: React.FC = () => {
  return (
    <BannerLink href={MAIS_SHOW_URL} target="_blank" rel="noopener noreferrer">
      <BannerImage
        src={banner}
        alt="A forma mais rápida e segura de contratar artistas. Marketplace com curadoria artística, tecnologia e cotação em até 24 horas."
        loading="lazy"
      />
    </BannerLink>
  )
}

export default MaisShowBanner
